// Minimal TouchEvent polyfill for non-touch environments.
// This ensures libraries that check for `window.TouchEvent` don't throw.
// Not a full TouchEvent implementation — only a harmless constructor placeholder.
if (typeof window !== 'undefined' && typeof window.TouchEvent === 'undefined') {
  // eslint-disable-next-line func-names
  window.TouchEvent = function TouchEvent() {};
}
